import { ILimit } from "./types.ts";
import { axiosInstance } from "../axiosConfig.ts";

const basePath = "/v1/limit";

export const limitAPI = {
  getLimit: async (): Promise<ILimit> => {
    const response = await axiosInstance.get<ILimit>(basePath);
    return response.data;
  },
};
